"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _createReactClass = _interopRequireDefault(require("create-react-class"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _I18n = _interopRequireDefault(require("I18n"));

var _enums = require("MeetingsBase/constants/enums");

var _UIList = _interopRequireDefault(require("UIComponents/list/UIList"));

var _UIFormControl = _interopRequireDefault(require("UIComponents/form/UIFormControl"));

var _UINumberInput = _interopRequireDefault(require("UIComponents/input/UINumberInput"));

var _UIRadioInput = _interopRequireDefault(require("UIComponents/input/UIRadioInput"));

var _UICheckbox = _interopRequireDefault(require("UIComponents/input/UICheckbox"));

var _UITextInput = _interopRequireDefault(require("UIComponents/input/UITextInput"));

var _UITextArea = _interopRequireDefault(require("UIComponents/input/UITextArea"));

var _UISelectInput = _interopRequireDefault(require("UIComponents/input/UISelectInput"));

var _UIToggleGroup = _interopRequireDefault(require("UIComponents/input/UIToggleGroup"));

var _UIDateInput = _interopRequireDefault(require("UIComponents/dates/UIDateInput"));

var _SimpleDate = require("UIComponents/core/SimpleDate");

var _ComponentWithPartials = _interopRequireDefault(require("UIComponents/mixins/ComponentWithPartials"));

var EMAIL_FIELD = 'email';
var BookingFormField = (0, _createReactClass.default)({
  mixins: [_ComponentWithPartials.default],
  propTypes: {
    fieldValue: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.array, _propTypes.default.object, _propTypes.default.number, _propTypes.default.bool]),
    fieldName: _propTypes.default.string.isRequired,
    validation: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.bool]),
    setFormValue: _propTypes.default.func.isRequired,
    autocomplete: _propTypes.default.string,
    fieldType: _propTypes.default.string,
    type: _propTypes.default.string,
    isRequired: _propTypes.default.bool,
    fieldLabel: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node]),
    fieldOptions: _propTypes.default.array,
    fieldIsCustom: _propTypes.default.bool,
    placeholder: _propTypes.default.string
  },
  getDefaultProps: function getDefaultProps() {
    return {
      autocomplete: 'off'
    };
  },
  getInitialState: function getInitialState() {
    return {
      hasBeenBlurred: false
    };
  },
  isNameField: function isNameField() {
    return ['firstName', 'lastName'].includes(this.props.fieldName);
  },
  getEnumOptions: function getEnumOptions(options) {
    return options.map(function (option) {
      return {
        text: option.label,
        value: option.value
      };
    });
  },
  onFieldBlur: function onFieldBlur() {
    this.setState({
      hasBeenBlurred: true
    });
  },
  handleEnumValueChange: function handleEnumValueChange(_ref) {
    var fieldName = _ref.fieldName,
        value = _ref.value;
    this.props.setFormValue(fieldName, value);
  },
  handleBooleanCheckboxValueChange: function handleBooleanCheckboxValueChange(e) {
    this.props.setFormValue(this.props.fieldName, e.target.checked);
  },
  handleValueChange: function handleValueChange(fieldName, e) {
    var value = e.target.value;

    if (fieldName === EMAIL_FIELD) {
      value = value.trim();
    }

    this.props.setFormValue(fieldName, value);
  },
  handleDateValueChange: function handleDateValueChange(fieldName, e) {
    this.props.setFormValue(fieldName, (0, _SimpleDate.toMomentUTC)(e.target.value).valueOf());
  },
  renderStandardField: function renderStandardField(FormFieldComponent) {
    var _this$props = this.props,
        fieldName = _this$props.fieldName,
        fieldValue = _this$props.fieldValue,
        autocomplete = _this$props.autocomplete,
        placeholder = _this$props.placeholder;
    return _react.default.createElement(FormFieldComponent, {
      style: {
        maxWidth: '100%'
      },
      autoComplete: autocomplete,
      type: "text",
      name: fieldName,
      className: "confirm-" + fieldName + "-field",
      value: fieldValue || '',
      onChange: this.partial(this.handleValueChange, fieldName),
      onBlur: this.onFieldBlur,
      placeholder: placeholder
    });
  },
  renderTextField: function renderTextField() {
    return this.renderStandardField(_UITextInput.default);
  },
  renderTextAreaField: function renderTextAreaField() {
    return this.renderStandardField(_UITextArea.default);
  },
  renderEnumType: function renderEnumType(renderFunction) {
    var fieldOptions = this.props.fieldOptions;
    return _react.default.createElement(_UIList.default, null, fieldOptions.map(function (option) {
      if (option.value !== '') {
        return renderFunction(option);
      }

      return null;
    }));
  },
  renderCheckbox: function renderCheckbox() {
    var _this$props2 = this.props,
        fieldValue = _this$props2.fieldValue,
        fieldLabel = _this$props2.fieldLabel,
        isRequired = _this$props2.isRequired,
        fieldName = _this$props2.fieldName;
    return _react.default.createElement(_UICheckbox.default, {
      className: "m-top-6",
      checked: fieldValue,
      onChange: this.handleBooleanCheckboxValueChange,
      onBlur: this.partial(this.onFieldBlur, {
        target: {
          name: fieldName
        }
      })
    }, fieldLabel, isRequired && _react.default.createElement("span", null, " * "));
  },
  renderRadioInput: function renderRadioInput(option) {
    var _this$props3 = this.props,
        fieldName = _this$props3.fieldName,
        fieldValue = _this$props3.fieldValue;
    return _react.default.createElement(_UIRadioInput.default, {
      key: option.value,
      name: option.value,
      text: option.label,
      checked: option.value === fieldValue,
      onChange: this.partial(this.handleEnumValueChange, {
        fieldName: fieldName,
        value: option.value
      }),
      onBlur: this.partial(this.onFieldBlur, {
        target: {
          name: fieldName
        }
      })
    });
  },
  renderSelectField: function renderSelectField() {
    var _this$props4 = this.props,
        fieldName = _this$props4.fieldName,
        fieldType = _this$props4.fieldType,
        fieldOptions = _this$props4.fieldOptions,
        fieldValue = _this$props4.fieldValue,
        setFormValue = _this$props4.setFormValue,
        placeholder = _this$props4.placeholder;
    var placeholderText = _I18n.default.text('select') || placeholder;

    if (fieldType === _enums.FORM_FIELD_TYPES.CHECKBOX) {
      var valueArray = fieldValue || [];
      return _react.default.createElement(_UIToggleGroup.default, {
        name: fieldName
      }, fieldOptions.map(function (option) {
        var checked = valueArray.includes(option.value);
        var onChange = checked ? function () {
          return setFormValue(fieldName, valueArray.filter(function (value) {
            return value !== option.value;
          }));
        } : function () {
          return setFormValue(fieldName, [].concat((0, _toConsumableArray2.default)(valueArray), [option.value]));
        };
        return {
          onChange: onChange,
          checked: checked,
          key: option.value,
          label: option.label
        };
      }).map(function (option) {
        var key = option.key,
            label = option.label,
            props = (0, _objectWithoutProperties2.default)(option, ["key", "label"]);
        return _react.default.createElement(_UICheckbox.default, (0, _extends2.default)({
          key: key
        }, props), label);
      }));
    } else {
      // Do not switch to UISelect despite deprecation warning in UILibrary
      // See https://git.hubteam.com/HubSpot/MeetingsUI/pull/1446
      return _react.default.createElement(_UISelectInput.default, {
        name: fieldName,
        onChange: this.partial(this.handleValueChange, fieldName),
        onBlur: this.onFieldBlur,
        options: this.getEnumOptions(fieldOptions),
        placeholder: placeholderText,
        value: fieldValue || undefined
      });
    }
  },
  renderEnumerationFields: function renderEnumerationFields() {
    var fieldType = this.props.fieldType;

    switch (fieldType) {
      case _enums.FORM_FIELD_TYPES.BOOLEAN_CHECKBOX:
        return this.renderCheckbox();

      case _enums.FORM_FIELD_TYPES.RADIO:
        return this.renderEnumType(this.renderRadioInput);

      default:
        return this.renderSelectField();
    }
  },
  renderNumberField: function renderNumberField() {
    var _this$props5 = this.props,
        fieldName = _this$props5.fieldName,
        fieldValue = _this$props5.fieldValue;
    return _react.default.createElement(_UINumberInput.default, {
      name: fieldName,
      onChange: this.partial(this.handleValueChange, fieldName),
      onBlur: this.onFieldBlur,
      value: fieldValue
    });
  },
  renderDateField: function renderDateField() {
    var fieldName = this.props.fieldName;
    return _react.default.createElement("div", {
      className: "meetings-date-input"
    }, _react.default.createElement(_UIDateInput.default, {
      placeholder: _I18n.default.moment.localeData().longDateFormat('L') || 'MM/DD/YYYY',
      onChange: this.partial(this.handleDateValueChange, fieldName),
      onBlur: this.onFieldBlur
    }));
  },
  renderInput: function renderInput() {
    var _this$props6 = this.props,
        fieldIsCustom = _this$props6.fieldIsCustom,
        type = _this$props6.type,
        fieldType = _this$props6.fieldType;

    switch (true) {
      case type === _enums.FORM_FIELD_TYPES.ENUMERATION:
        return this.renderEnumerationFields();

      case type === _enums.FORM_FIELD_TYPES.NUMBER:
        return this.renderNumberField();

      case type === _enums.FORM_FIELD_TYPES.DATE:
        return this.renderDateField();

      case fieldIsCustom || fieldType === _enums.FORM_FIELD_TYPES.TEXTAREA:
        return this.renderTextAreaField();

      default:
        return this.renderTextField();
    }
  },
  render: function render() {
    var _this$props7 = this.props,
        validation = _this$props7.validation,
        isRequired = _this$props7.isRequired,
        fieldLabel = _this$props7.fieldLabel,
        fieldType = _this$props7.fieldType;
    var hasError = Boolean(validation) && this.state.hasBeenBlurred;
    var validationMessage;

    if (hasError) {
      validationMessage = validation;
    }

    var classes = (0, _classnames.default)({
      'm-top-6': !this.isNameField()
    });
    var isBooleanCheckbox = fieldType === _enums.FORM_FIELD_TYPES.BOOLEAN_CHECKBOX;
    return _react.default.createElement(_UIFormControl.default, {
      className: classes,
      label: !isBooleanCheckbox && fieldLabel,
      required: isRequired,
      error: hasError,
      validationMessage: validationMessage,
      onBlur: this.onFieldBlur
    }, this.renderInput());
  }
});
var _default = BookingFormField;
exports.default = _default;
module.exports = exports.default;